// extracted by mini-css-extract-plugin
export default {"bmwBody":"cWOxEU2l3Rc8GQrjUzco","miniBody":"hNWNDu8rDpczychWikrS"};